import AssertionEntity from '../../lib/FormValidator/Assertion/AssertionEntity';
import AssertionItem from '../../lib/FormValidator/Assertion/AssertionItem';
export class PartidoOfflineAssertions extends AssertionEntity {
  private constructor() {
    super();
  }

  static build() {
    const instance = new this();
    instance.addAssertionForClubLocal();
    instance.addAssertionForClubVisitante();
    // instance.addAssertionForRama();
    return instance;
  }

  addAssertionForClubLocal(key = 'paro_club_local') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Club local es obligatorio'
      )
    );
  }

  addAssertionForClubVisitante(key = 'paro_club_visitante') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Club visitante es obligatorio'
      )
    );
  }

  // addAssertionForRama(key = 'paro_rama') {
  //   this.defineAssertionForProperty(
  //     key,
  //     AssertionItem.forClosure(
  //       (value) => {
  //         return value !== '';
  //       },
  //       key,
  //       'Rama es obligatorio'
  //     )
  //   );
  // }
}
